export interface ApplicationError {
  message: {
    title?: string;
    subTitle?: string[];
    toast?: string;
  };
  critical: boolean;
  showHomeButton?: boolean;
  showLoginButton?: boolean;
}

const unknownTechnicalError = () => ({
  critical: true,
  message: {
    title: "technicalError.title",
    subTitle: ["technicalError.subtitle"],
  },
  showHomeButton: true,
});

export const handleUserProviderErrors = (error: any): ApplicationError => {
  let applicationError: ApplicationError = {
    critical: false,
    message: {},
  };
  if (error.response) {
    if (error.response.status === 401) {
      applicationError.critical = true;
      applicationError.message.title = "user.authentication.failed.title";
      applicationError.message.subTitle = ["authentication.failed.subtitle"];
      applicationError.showHomeButton = true;
    } else if (error.response.status < 404) {
      applicationError.critical = true;
      applicationError.message.title = "user.error.authorization.title";
      applicationError.message.subTitle = ["error.authorization.subtitle"];
      applicationError.showLoginButton = true;
    } else if (error.response.status === 404) {
      applicationError.critical = true;
      applicationError.message.title = "user.error.authorization.title";
      applicationError.message.subTitle = [
        "authentication.failed.noAccountsMapped",
        "error.authorization.subtitle",
      ];
      applicationError.showHomeButton = true;
    } else {
      applicationError = unknownTechnicalError();
    }
  } else if (error.isCorporateViewOnly) {
    applicationError.critical = true;
    applicationError.message.title =
      "error.unauthorized.corporateViewOnly.title";
    applicationError.message.subTitle = [
      "error.unauthorized.corporateViewOnly.subtitle1",
      "error.unauthorized.corporateViewOnly.subtitle2",
    ];
    applicationError.showHomeButton = true;
  } else if (error.roles && error.roles.length === 0) {
    applicationError.critical = true;
    applicationError.message.title = "user.error.authorization.title";
    applicationError.message.subTitle = [
      "authentication.failed.noRolesMapped",
      "error.authorization.subtitle",
    ];
    applicationError.showHomeButton = true;
  } else {
    applicationError = unknownTechnicalError();
  }
  return applicationError;
};
